import { MenuEffects } from './menu-effects';
import { UserEffects } from "./user-effects";

export const ALL_EFFECTS = [
    MenuEffects,
    UserEffects
];
